import React from 'react'

const SectionTitle = ({ title, subtitle }) => {
    return (
        <h3 className="fs1-25rem c15 w100"> {title}
            <br />
            <span className="c59">{subtitle}</span>
        </h3>
    )
}

export default SectionTitle;